import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import PartsList from 'pages/parts/PartsList';
import arrowRightOutlineIcon from '@iconify/icons-eva/arrow-right-outline';
import arrowIosForwardOutlineIcon from '@iconify/icons-eva/arrow-ios-forward-outline';
import deleteTwotoneIcon from '@iconify/icons-ant-design/delete-twotone';
import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import useMutation, { METHOD } from 'hook/useMutation';
import { toast } from 'react-toastify';
import useLazyQuery from 'hook/useLazyQuery';
import { AxiosResponse } from 'axios';
import { useNavigate, useParams } from 'react-router';
import isEqual from 'lodash/isEqual';
import { PartsButton, PartsSelectedButton } from './style';

export function ChallengeConditions() {
  const navigate = useNavigate();
  const param = useParams();
  const [selectedParts, setSelectedParts] = useState(1);
  const [selectedConditions, setSelectedConditions] = useState<
    IChallengeConditions[]
  >([]);
  const partQuery = useQuery<PartResponse>(API_PATH.PARTS);
  const workoutQuery = useQuery<WorkoutResponse>(API_PATH.WORKOUTS, {
    part_id: selectedParts,
  });
  const [originData, setOriginData] = useState<IChallengeConditions[] | null>(
    null,
  );
  const challengeConditionById = useLazyQuery<IChallengeConditionsResponse>(
    `${API_PATH.CHALLENGES_CONDITIONS}`,
    {
      param: {
        challenge_id: param.id,
      },
      onSuccess: (res: AxiosResponse<IChallengeConditionsResponse, any>) => {
        const { data } = res;

        setSelectedConditions(data.results);
        setOriginData(data.results);
      },
    },
  );

  const postChallengeConditions = useMutation<IPostChallengeConditions>(
    `${API_PATH.POST_CHALLENGES_CONDITIONS}?challenge_id=${Number(param.id)}`,
    {
      method: METHOD.POST,
      onSuccess: () => {
        toast.success('등록이 완료되었습니다.');
        // workoutQuery.resetQuery();
        navigate(`/challenges/modify/${param.id}/routines`);
      },
    },
  );

  const onClickWorkoutClick = (workout: Workout) => {
    const addCondition = {
      id: undefined,
      workout_id: workout.id,
      part: workout.part.name,
      name: workout.name,
      display_order: workout.display_order,
    } as IChallengeConditions;

    setSelectedConditions(
      Array.from(new Set([...selectedConditions, addCondition])),
    );
  };

  const deleteCondition = (selectedWorkout: IChallengeConditions) => {
    setSelectedConditions(
      selectedConditions.filter((item) => item.id !== selectedWorkout.id),
    );
  };

  const onClickSaveAndNext = () => {
    const challengeId = Number(param.id);

    if (challengeId) {
      if (isEqual(originData, selectedConditions)) {
        navigate(`/challenges/modify/${challengeId}/routines`);
      } else {
        const params: IPostChallengeConditions = {
          challenge_conditions: selectedConditions.map((item) => {
            return {
              id: item.id,
              workout_id: item.workout_id,
            };
          }),
        };

        postChallengeConditions.mutate(params);
      }
    }
  };

  useEffect(() => {
    if (
      param.id &&
      !challengeConditionById.data &&
      !challengeConditionById.error
    ) {
      challengeConditionById.refetch();
    }
  }, [param, challengeConditionById]);

  useEffect(() => {
    challengeConditionById.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <PartsList
        selectedParts={selectedParts}
        setSelectedParts={setSelectedParts}
        parts={partQuery.getQuery.data?.data.results || []}
      />
      <Grid
        container
        spacing={2}
        justifyContent='center'
        alignItems='center'
        sx={{ width: '100%', height: 'calc(100vh - 116px - 72px - 50px)' }}
      >
        <Grid
          item
          sx={{
            flex: 1,
            overflowY: 'auto',
            height: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px 0px',
              width: '100%',
            }}
          >
            {workoutQuery.getQuery.data?.data.results.map((workout) => (
              <PartsButton
                key={workout.id}
                variant='contained'
                size='large'
                onClick={() => onClickWorkoutClick(workout)}
                endIcon={<Icon icon={arrowRightOutlineIcon} />}
              >
                {workout.name}
              </PartsButton>
            ))}
          </Box>
        </Grid>
        <Grid item>
          <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Icon icon={arrowIosForwardOutlineIcon} fontSize={40} />
          </Box>
        </Grid>
        <Grid item sx={{ flex: 1, overflowY: 'auto', height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px 0px',
              width: '100%',
            }}
          >
            {selectedConditions.map((selectedCondition) => (
              <PartsSelectedButton
                key={selectedCondition.id}
                variant='contained'
                size='large'
                onClick={() => deleteCondition(selectedCondition)}
                endIcon={<Icon icon={deleteTwotoneIcon} />}
              >
                {selectedCondition.name}
              </PartsSelectedButton>
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* <Stack>
          <Stack direction='row'>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px 0px',
                width: '100%',
              }}
            >
              {workoutQuery.getQuery.data?.data.results.map((workout) => (
                <PartsButton
                  key={workout.id}
                  variant='contained'
                  size='large'
                  onClick={() => onClickWorkoutClick(workout)}
                  endIcon={<Icon icon={arrowRightOutlineIcon} />}
                >
                  {workout.name}
                </PartsButton>
              ))}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
              <Icon icon={arrowIosForwardOutlineIcon} fontSize={40} />
            </Box>
          </Stack>
        </Stack>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px 0px',
            width: { xs: '100%', md: '50%' },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', height: 63 }}>
            <Typography variant='subtitle2'>목록</Typography>
          </Box>
          {selectedConditions.map((selectedCondition) => (
            <PartsSelectedButton
              key={selectedCondition.id}
              variant='contained'
              size='large'
              onClick={() => deleteCondition(selectedCondition)}
              endIcon={<Icon icon={deleteTwotoneIcon} />}
            >
              {selectedCondition.name}
            </PartsSelectedButton>
          ))}
        </Box> */}
      <Stack
        direction='row'
        sx={{
          gap: '0px 8px',
          width: '100%',
          marginTop: 2,
        }}
      >
        <Button
          variant='contained'
          color='info'
          fullWidth
          onClick={() => navigate(`/challenges/modify/${param.id}/info`)}
        >
          이전
        </Button>
        <Button variant='contained' fullWidth onClick={onClickSaveAndNext}>
          저장(다음)
        </Button>
      </Stack>
    </Box>
  );
}
